/**
 * call-clock — formats the "Connected · HH:MM" wall-clock chip (design
 * refs: t17-head-and-screen.html's 17a, t17cd.html's 17d). The timestamp is
 * captured once, when the call first reaches `live` (see call-screen.tsx's
 * `liveAtRef`), and rendered wherever the docked transcript shows it —
 * mobile's centered pill and desktop's rail-header text (transcript-rail.tsx)
 * share this one formatter so the two surfaces can't drift on format (locale
 * hour:minute, no seconds — e.g. "10:42").
 */

export function formatConnectedClock(epochMs: number): string {
  return new Date(epochMs).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  });
}
